import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core';
import {ReactFeatureApp} from '@feature-hub/react';
import React from 'react';
import {App} from './app';
import {FeatureServicesContext} from './use-feature-services';
import dependencies from './dependencies.json';
import {HistoryServiceV2} from '@feature-hub/history-service';
import {ApiKeyProviderV1} from '@volkswagen-onehub/api-key-provider';
import {DisclaimerManagerV1} from '@volkswagen-onehub/disclaimer-manager';
import {LayerManagerV24} from '@volkswagen-onehub/layer-manager';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';
import {ServiceConfigProviderV1} from '@volkswagen-onehub/service-config-provider';
import {PageInfoServiceV1} from '@volkswagen-onehub/page-info-service';
import {BreadcrumbServiceV1} from '@volkswagen-onehub/breadcrumb-service';
import {TrackingManagerV1} from '@volkswagen-onehub/tracking-service';
import {GetUserLocationManagerV1} from '@volkswagen-onehub/user-location-manager';
import {
  FeatureAppConfigContext,
  FeatureAppConfig
} from './use-feature-app-configs';
import {LayerContextProvider, LayersPortaled} from './components/Layers';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';
import { CompareDimensionsFaContentService } from './types/content';
import { COMPONENTS_CORE_VERSION } from '@volkswagen-onehub/components-core';

export interface StarterFeatureAppDependencies extends FeatureServices {
  readonly 'api-key-provider'?: ApiKeyProviderV1;
  readonly 'disclaimer-manager': DisclaimerManagerV1;
  readonly 'fa-content-service'?: CompareDimensionsFaContentService;
  readonly 'featureapp-service'?: FeatureappServiceV1;
  readonly 'layer-manager': LayerManagerV24;
  readonly 'locale-service': LocaleServiceV1;
  readonly 's2:history': HistoryServiceV2;
  readonly 's2:logger'?: Logger;
  readonly 'service-config-provider': ServiceConfigProviderV1;
  readonly 'page-info-service': PageInfoServiceV1;
  readonly 'breadcrumb-service': BreadcrumbServiceV1;
  readonly 'user-location-manager': GetUserLocationManagerV1;
  readonly 'tracking': TrackingManagerV1;
}

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  StarterFeatureAppDependencies
> = {
  ...dependencies,

  create: (env) => {
    const {config, featureServices} = env;

    return {
      render: () => {
        return (
          <FeatureServicesContext.Provider value={featureServices}>
            <LayerContextProvider>
              <FeatureAppConfigContext.Provider
                value={config as FeatureAppConfig}
              >
                <App />
                <LayersPortaled />
              </FeatureAppConfigContext.Provider>
            </LayerContextProvider>
          </FeatureServicesContext.Provider>
        );
      }
    };
  }
};

export default featureAppDefinition;

type VwcaDebug = {appComponentsCoreVersions?: Record<string, string>; printAppComponentsCoreVersions?(): void};
const w = window as unknown as {vwca: VwcaDebug};
w.vwca = w.vwca || {};
const appVersions: Record<string, string> = w.vwca.appComponentsCoreVersions = w.vwca.appComponentsCoreVersions || {};
// eslint-disable-next-line no-console
w.vwca.printAppComponentsCoreVersions = w.vwca.printAppComponentsCoreVersions || (() => console.table(appVersions));
appVersions['compare-dimensions'] = COMPONENTS_CORE_VERSION;
